export default "__VITE_ASSET__DsxkSgiL__"